;(function($) {
    'use strict';
    $(document).ready(function() {
        $('form[data-validate]').each(function() {
            $(this).on('blur', 'input[data-validate]:not([type=checkbox], [type=radio]), select[data-validate], textarea[data-validate]', function() {
                $(this).closest('form').validated({fields: this});
            });
            $(this).on('click', 'input[data-validate][type=checkbox], input[data-validate][type=radio]', function(event) {
                var $input = $(this);
                var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
                $siblings.closest('label').removeClass('selected');
                $siblings.filter(':checked').each(function() {
                    $(this).closest('label').addClass('selected');
                });
                $(this).closest('form').validated({fields: this});
            });
            $(this).on('click', '[data-step]', function(event) {
                event.preventDefault();
                var $self = $(this);
                var $form = $self.closest("form");
                var $target = $form.find($self.attr("href") || $self.data("target"));
                var validate = !!$self.data("validate");
                var step = $self.data("step") || 0;
                if (validate) {
                    $form.validated({data: {step: step}, files: true, submit: true}, function(validated, response) {
                        if (response.success && response.message) {
                            $form.empty().append( 
                                $('<div class="feedback success">').html(response.message)
                            );
                        }
                        validated && $target.tab("show");
                    });
                } else {
                    $target.tab("show");
                    $form.validated("clearTooltips");
                }
            });
        });
    });
})(jQuery);